import { Button, DialogActions, Grid } from "@mui/material";
import Modal from "../../../components/modal";
import { Receipt } from "@mui/icons-material";
import TerminalsDropdown from "../filters/terminal";
import { useState } from "react";

const CreateSettlementModal = ({ onClose, onCreate }) => {
  const [terminalId, setTerminalId] = useState();

  return (
    <Modal
      open
      title='Crear Cierre de Lote'
      dividers
      customButtons={() => (
        <DialogActions>
          <Button
            onClick={onClose}
            variant='outlined'
            color='primary'
          >
            Cancelar
          </Button>
          <Button
            onClick={() => onCreate(terminalId)}
            variant='contained'
            color='primary'
            startIcon={<Receipt />}
          >
            Crear
          </Button>
        </DialogActions>
      )}
    >
      <Grid container spacing={1}>
        <Grid size={12}>
          <TerminalsDropdown selected={terminalId} onChange={(e) => setTerminalId(e.target.value)} />
        </Grid>
      </Grid>
    </Modal>
  );
}

export default CreateSettlementModal;